import React from 'react';

import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { borderRadius, Col, Cols, spacing, Text, TextButton } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IActionPillProps {
  isBlocked: boolean;
  isDisabled: boolean;
  isButton: boolean;
  muted: boolean;
  onClick: () => void;
}

export const ActionPill = ({
  isBlocked = false,
  isButton = false,
  isDisabled = false,
  muted = false,
  onClick,
}: IActionPillProps): React.ReactNode => {
  let pillColor = isBlocked ? publicaColors.red : publicaColors.green;
  if (muted) {
    pillColor = publicaColors.gray;
  }

  return (
    <TextButton disabled={isDisabled} onClick={onClick}>
      <Cols
        gap={spacing.extraSmall}
        style={{
          alignItems: 'center',
          backgroundColor: pillColor + '1a',
          borderRadius: borderRadius.small,
          width: 'fit-content',
          padding: isButton
            ? `${spacing.extraSmall} ${spacing.small}`
            : `${spacing.none} ${spacing.small}`,
        }}
      >
        <Col displayFlex style={{ alignItems: 'center' }}>
          <IconV2 name={isBlocked ? 'unavailable' : 'unlock'} color={pillColor} />
        </Col>
        <Col>
          <Text tKey={isBlocked ? 'Blocked' : 'Allowed'} small bold color={pillColor} />
        </Col>
      </Cols>
    </TextButton>
  );
};
